import { EditableFileName } from './EditableFileName';

interface DeterministicSuggestionCardProps {
  suggestion: string;
  /** The `wasEdited` flag is forwarded from EditableFileName: true when the
   * click came from edit-mode commit, false when from view-mode acceptAsIs.
   * Lets the parent decide whether to preserve a typed buffer on rejection. */
  onAccept: (fullFilename: string, opts: { wasEdited: boolean }) => Promise<void> | void;
  isAccepting: boolean;
  /** Full filename to seed EditableFileName's edit buffer with on mount.
   * Used to restore the user's typed name after an accept-failure remount;
   * pass undefined on the normal first mount. */
  initialEditBuffer?: string;
  /** One-shot callback fired by EditableFileName on mount after it has read
   * the initialEditBuffer, so the parent can clear its stash and avoid
   * resurrecting the same buffer on a later remount. */
  onEditBufferConsumed?: () => void;
  onboardingSpotlight?: boolean;
}

// Thin wrapper over EditableFileName. The suggestion always carries the
// canonical file extension (enforced by the backend); we forward whatever the
// user accepts (edited or not) as the explicit name so the parent can drive
// the accept mutation against the freshly-rendered suggestion, not the backend
// cache which may lag a template change.
export const DeterministicSuggestionCard = ({
  suggestion,
  onAccept,
  isAccepting,
  initialEditBuffer,
  onEditBufferConsumed,
  onboardingSpotlight,
}: DeterministicSuggestionCardProps) => (
  <EditableFileName
    variant="suggestion"
    value={suggestion}
    isAccepting={isAccepting}
    onAccept={onAccept}
    initialEditBuffer={initialEditBuffer}
    onEditBufferConsumed={onEditBufferConsumed}
    onboardingSpotlight={onboardingSpotlight}
  />
);
